import React from 'react';
import { GroupedProcess } from "@baseTypes/service/dashboard/IWorksDashboardService";
import List from "../../../../../../components/elements/list/List";
import WorkItem from '../../../components/WorkItem/WorkItem';

type ProcessByCropsProps = {
    data: GroupedProcess['progressByCrop']
    barsSize: number
}

const ProcessByCrops = (props: ProcessByCropsProps) => {
    const { data, barsSize } = props;

    return (
        <List wrap={false} gap={0}>
            {data?.map((item, index) =>
                <WorkItem
                    key={`${item.groupName}-${index}`}
                    barsWidth={barsSize}
                    work={{
                        color: item.color || '',
                        season: { cropPeriods: [], cultivatedArea: item.season.fact, totalArea: item.season.plan },
                        today: { cropPeriods: [], cultivatedArea: item.today.fact, totalArea: item.today.plan },
                        displayName: item.groupName || '',
                    }}
                />
            )}
        </List>
    )
}

export default ProcessByCrops;